import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { brandName, heroBadges, heroImage, stats } from '../data/copy';
import { HERO_SIZES, HERO_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/image';
export function Hero() {
  return <header className="w-full bg-ink" data-id="element-134" data-mp="4mi5rhhqm0hn">
      {/* Mobile: promise → mockup → details. Desktop: copy left, mockup right. */}
      <div className="mx-auto grid max-w-6xl gap-x-12 px-6 pb-8 pt-6 sm:pt-10 lg:grid-cols-[1fr_1.1fr] lg:items-center lg:pb-12 lg:pt-12" data-id="element-135" data-mp="128yye9fizpx2">
        <div className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-136" data-mp="sbb0xbqjc4b7">
          <Pill tone="accent" data-id="element-137" data-mp="sd48ct8z2sk9">For volleyball coaches</Pill>

          <h1 className="mt-5 font-display text-[2.6rem] font-extrabold uppercase leading-[0.92] text-fg sm:text-6xl lg:text-[4.4rem]" style={{
          fontSize: "32px"
        }} data-id="element-138" data-mp="nbop96qcuw4i">
            Plan your next volleyball practice in{' '}
            <span className="text-accent" data-id="element-139" data-mp="3j8iyd2s0imwa">5 minutes</span>
          </h1>

          
        </div>

        <div className="relative mt-8 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mt-0" data-id="element-140" data-mp="3j6o8da1vw4lc">
          <div className="absolute inset-x-0 bottom-6 top-10 rounded-[2rem] bg-panel ring-1 ring-line" aria-hidden="true" data-id="element-141" data-mp="3o59efq3thihp" />
          <img src={optimizedImage(heroImage, 960)} srcSet={optimizedSrcSet(heroImage, HERO_WIDTHS)} sizes={HERO_SIZES} alt="VOLLEYBALL 360 READY™ complete: 6 visual coaching volumes, a practice-plan tablet view, and 5 practical coaching bonuses." className="relative mx-auto w-full max-w-md drop-shadow-xl sm:max-w-xl" width={1240} height={1240} decoding="sync" loading="eager" {...{
          fetchpriority: 'high'
        }} style={{
          width: "338px",
          height: "349px"
        }} data-id="element-142" data-mp="3e963buqzm9im" />
        </div>

        <div className="mt-6 text-center lg:col-start-1 lg:row-start-2 lg:mt-6 lg:self-start lg:text-left" data-id="element-143" data-mp="2hix2g62bkrr6">
          <p className="mx-auto max-w-xl leading-relaxed text-muted lg:mx-0" style={{
          fontSize: "12px"
        }} data-id="element-144" data-mp="2ljpch1j0n0oi">
            The complete digital PDF system for volleyball coaches: step-by-step
            technique, illustrated drills, progressions, court diagrams, common
            mistakes, quick fixes, decision-making exercises, and complete
            practices already organized for you.
          </p>

          <div className="mt-7" data-id="element-145" data-mp="deyke41ik3c4">
            <CtaButton href="#offer" size="large" className="w-full sm:w-auto" data-id="element-146" data-mp="1b0vupe5qp2cz">
              Get full access now
            </CtaButton>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-147" data-mp="162c9xh2vtwm7">
            {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 text-sm text-muted" data-id="element-148" data-mp="114swukhx7pvu">
                <CheckIcon className="h-4 w-4 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-149" data-mp="x0uwy7krub1q" />
                {badge}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-y border-line bg-navy" data-id="element-150" data-mp="3hqkamh9qnqsu">
        <dl className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-line px-2 sm:px-6" data-id="element-151" data-mp="1x9b0knlp8d68">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse px-2 py-7 text-center" data-id="element-152" data-mp="21aehzejeah9k">
              <dt className="mt-2 font-display text-xs font-semibold uppercase tracking-[0.14em] text-muted sm:text-sm" data-id="element-153" data-mp="26a999j7318v5">
                {stat.label}
              </dt>
              <dd className="font-display text-5xl font-extrabold leading-none text-accent sm:text-6xl" data-id="element-154" data-mp="2b2so0jhiaa1j">
                {stat.value}
              </dd>
            </div>)}
        </dl>
        <p className="border-t border-line bg-accent py-3 text-center font-display text-sm font-bold uppercase tracking-[0.4em] text-on-accent" data-id="element-155" data-mp="2kxc9hxmshvm6">
          Courtside ready
        </p>
      </div>
    </header>;
}